import { useIntl } from 'react-intl'

import { assetSvgPath } from 'interfaces/constants'

import {
  StyledCardBody,
  StyledCardHeading,
  StyledWorkshopCard,
  StyledWorkshopInfoRow,
  StyledWorkshopDateText,
  StyledWorkshopIcon,
  StyledSubscribeButton,
  StyledWorkshopLocationText,
} from './index.styled'

type WorkshopCardProps = {
  workshop: Workshop
  onSubscribe: (workshop: Workshop) => void
}
export const WorkshopCard = ({ workshop, onSubscribe }: WorkshopCardProps) => {
  const { formatMessage: f } = useIntl()
  return (
    <StyledWorkshopCard>
      <StyledCardHeading banner={workshop.image}></StyledCardHeading>
      <StyledCardBody>
        <StyledWorkshopInfoRow>
          <StyledWorkshopIcon src={`${assetSvgPath}/calendar.svg`} />
          <StyledWorkshopDateText>{workshop.time}</StyledWorkshopDateText>
        </StyledWorkshopInfoRow>
        <StyledWorkshopInfoRow>
          <StyledWorkshopIcon src={`${assetSvgPath}/clock.svg`} />
          <StyledWorkshopDateText>{workshop.timeRange}</StyledWorkshopDateText>
        </StyledWorkshopInfoRow>
        <StyledWorkshopInfoRow>
          <StyledWorkshopIcon src={`${assetSvgPath}/location.svg`} />
          <StyledWorkshopLocationText
            title={workshop.location}
            href={workshop.locationUrl || undefined}
            target="_blank"
          >
            {workshop.location}
          </StyledWorkshopLocationText>
        </StyledWorkshopInfoRow>
        <StyledSubscribeButton
          disabled={!workshop.active}
          onClick={() => onSubscribe(workshop)}
        >
          {workshop.active
            ? f({
                id: 'spotlight.workshop.subscribeNow',
                defaultMessage: 'Subscribe Now',
              })
            : f({
                id: 'spotlight.workshop.comingSoon',
                defaultMessage: 'Coming Soon',
              })}
        </StyledSubscribeButton>
      </StyledCardBody>
    </StyledWorkshopCard>
  )
}
